export const ORDER_CREATE_REQUEST = "ORDER_CREATE_REQUEST";
export const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAIL = "ORDER_CREATE_FAIL";

export const ORDER_CREATE_RESET = "ORDER_CREATE_RESET";

export const CUSTOM_ORDER_CREATE_REQUEST = "CUSTOM_ORDER_CREATE_REQUEST";
export const CUSTOM_ORDER_CREATE_SUCCESS = "CUSTOM_ORDER_CREATE_SUCCESS";
export const CUSTOM_ORDER_CREATE_FAIL = "CUSTOM_ORDER_CREATE_FAIL";

export const CUSTOM_ORDER_CREATE_RESET = "CUSTOM_ORDER_CREATE_RESET";

export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";

export const ORDER_PAY_REQUEST = "ORDER_PAY_REQUEST";
export const ORDER_PAY_SUCCESS = "ORDER_PAY_SUCCESS";
export const ORDER_PAY_FAIL = "ORDER_PAY_FAIL";
export const ORDER_PAY_RESET = "ORDER_PAY_RESET";

export const ORDER_BACK_REQUEST = "ORDER_BACK_REQUEST";
export const ORDER_BACK_SUCCESS = "ORDER_BACK_SUCCESS";
export const ORDER_BACK_FAIL = "ORDER_BACK_FAIL";
export const ORDER_BACK_RESET = "ORDER_PAY_RESET";

export const ORDER_LIST_MY_REQUEST = "ORDER_LIST_MY_REQUEST";
export const ORDER_LIST_MY_SUCCESS = "ORDER_LIST_MY_SUCCESS";
export const ORDER_LIST_MY_FAIL = "ORDER_LIST_MY_FAIL";
export const ORDER_LIST_MY_RESET = "ORDER_LIST_MY_RESET";

export const ORDER_LIST_REQUEST = "ORDER_LIST_REQUEST";
export const ORDER_LIST_SUCCESS = "ORDER_LIST_SUCCESS";
export const ORDER_LIST_FAIL = "ORDER_LIST_FAIL";

export const ORDER_DELIVER_REQUEST = "ORDER_DELIVER_REQUEST";
export const ORDER_DELIVER_SUCCESS = "ORDER_DELIVER_SUCCESS";
export const ORDER_DELIVER_FAIL = "ORDER_DELIVER_FAIL";
export const ORDER_DELIVER_RESET = "ORDER_DELIVER_RESET";

export const ORDER_RECIEVE_REQUEST = "ORDER_RECIEVE_REQUEST";
export const ORDER_RECIEVE_SUCCESS = "ORDER_RECIEVE_SUCCESS";
export const ORDER_RECIEVE_FAIL = "ORDER_RECIEVE_FAIL";
export const ORDER_RECIEVE_RESET = "ORDER_RECIEVE_RESET";

export const ORDER_INITIALIZE_PAYMENT_REQUEST =
	"ORDER_INITIALIZE_PAYMENT_REQUEST";
export const ORDER_INITIALIZE_PAYMENT_SUCCESS =
	"ORDER_INITIALIZE_PAYMENT_SUCCESS";
export const ORDER_INITIALIZE_PAYMENT_FAIL = "ORDER_INITIALIZE_PAYMENT_FAIL";
